import ReactDatePicker from 'react-datepicker'
import { FormReactDatePickerProps } from '../../../models/reactDatePicker.type'
import dayjs from '../../../utils/DayjsUtil'
import Select, { SingleValue } from 'react-select'
import React, { useEffect, useState } from 'react'
import { customStyles, Opcion } from '../select/FormSelect'
import es from 'date-fns/locale/es'

/**
 * Date Picker completo con header personalizado (select de mes/anio),
 * soporte para hora, rango de anios configurable y locale es-MX.
 */
export const FormReactDatePicker = ({
  placeholderText,
  onChange,
  name,
  required,
  value,
  dateFormat,
  isClearable = true,
  cantidadAniosPrevios=60,
  cantidadAniosSiguientes=60,
  disabled,
  minDate,
  maxDate,
  closeOnScroll,
  showTimeSelect,
  timeFormat,
  timeIntervals,
  fixedHeight,
  popperPlacement,
}: FormReactDatePickerProps) => {
  const anioActual = new Date().getFullYear()
  const rangoAnios = (start: number, stop: number, step: number) =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step)
  const rangoPrevio = rangoAnios(anioActual, anioActual - cantidadAniosPrevios, -1)
  const rangoSiguiente = rangoAnios(anioActual + 1, anioActual + cantidadAniosSiguientes, +1)
  const rangoTotalAnios = [...rangoPrevio].reverse().concat(rangoSiguiente)
  const [elementosRangoAnios, setElementosRangoAnios] = useState<
    { etiqueta: string; valor: string }[] | undefined
  >()

  const objetoAnios = () => {
    const elementosAnios = []
    for (let i = 0; i <= rangoTotalAnios.length; i++) {
      elementosAnios.push({
        etiqueta: rangoTotalAnios[i]?.toString(),
        valor: rangoTotalAnios[i]?.toString(),
      })
    }
    setElementosRangoAnios(elementosAnios)
  }

  useEffect(() => {
    objetoAnios()
  }, [])

  const elementosMeses = [
    { etiqueta: 'Enero', valor: 'ENERO' },
    { etiqueta: 'Febrero', valor: 'FEBRERO' },
    { etiqueta: 'Marzo', valor: 'MARZO' },
    { etiqueta: 'Abril', valor: 'ABRIL' },
    { etiqueta: 'Mayo', valor: 'MAYO' },
    { etiqueta: 'Junio', valor: 'JUNIO' },
    { etiqueta: 'Julio', valor: 'JULIO' },
    { etiqueta: 'Agosto', valor: 'AGOSTO' },
    { etiqueta: 'Septiembre', valor: 'SEPTIEMBRE' },
    { etiqueta: 'Octubre', valor: 'OCTUBRE' },
    { etiqueta: 'Noviembre', valor: 'NOVIEMBRE' },
    { etiqueta: 'Diciembre', valor: 'DICIEMBRE' },
  ]

  return (
    <ReactDatePicker
      wrapperClassName='form-select-autocomplete'
      autoComplete='off'
      closeOnScroll={closeOnScroll}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      required={required}
      locale={es}
      name={name}
      dateFormat={dateFormat}
      placeholderText={placeholderText}
      selected={value ? new Date(value) : undefined}
      onChange={onChange}
      className='form-control form-control-solid '
      useWeekdaysShort={true}
      tabIndex={0}
      isClearable={isClearable}
      showTimeSelect={showTimeSelect}
      timeFormat={timeFormat}
      timeIntervals={timeIntervals}
      fixedHeight={fixedHeight ? fixedHeight : true}
      popperPlacement={popperPlacement ? popperPlacement : 'top-end'}
      timeCaption='Hora'
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div
          style={{
            marginLeft: '10px',
            marginRight: '10px',
            display: 'flex',
            justifyContent: 'center',
          }}>
          <button
            style={{ height: '42px' }}
            type='button'
            className='btn btn-primary p-3'
            onClick={decreaseMonth}
            disabled={prevMonthButtonDisabled}>
            {'<'}
          </button>
          <div style={{ minWidth: '200px', paddingTop: '0px' }} className='d-flex'>
            <div className='mx-2' style={{ minWidth: '150px', height: '42px' }}>
              <Select
                components={{ Option: null || Opcion }}
                options={elementosMeses}
                className='form-select-autocomplete'
                styles={customStyles}
                getOptionLabel={(option) => option.etiqueta}
                getOptionValue={(option) => option.valor}
                value={elementosMeses[dayjs(date).month()]}
                onChange={(e: SingleValue<{ etiqueta: string; valor: string }>) => {
                  e && changeMonth(elementosMeses.indexOf(e))
                }}></Select>
            </div>

            <div className='mx-2' style={{ minWidth: '100px' }}>
              <Select
                components={{ Option: null || Opcion }}
                options={elementosRangoAnios}
                className='form-select-autocomplete'
                styles={customStyles}
                getOptionLabel={(option) => option.etiqueta}
                getOptionValue={(option) => option.valor}
                value={{
                  valor: dayjs(date).year().toString(),
                  etiqueta: dayjs(date).year().toString(),
                }}
                onChange={(e: SingleValue<{ etiqueta: string; valor: string }>) => {
                  e && changeYear(parseInt(e.etiqueta, 10))
                }}></Select>
            </div>
          </div>
          <button
            style={{ height: '42px' }}
            type='button'
            className='btn btn-primary p-3'
            onClick={increaseMonth}
            disabled={nextMonthButtonDisabled}>
            {'>'}
          </button>
        </div>
      )}
    />
  )
}
